import React from "react";
import Page from "../../Page";
import styles from "../CenterMobileIRepairMobile/CenterMobileIRepairMobile.module.css";
import CenterMobileIRepairMobileBanner from "../CenterMobileIRepairMobileBanner/CenterMobileIRepairMobileBanner";
import CenterMobileIRepairMobileCallback from "../CenterMobileIRepairMobileCallback/CenterMobileIRepairMobileCallback";
import CenterMobileIRepairMobileInfo from "../CenterMobileIRepairMobileInfo/CenterMobileIRepairMobileInfo";
import CenterMobileIRepairMobileAdvantages from "../CenterMobileIRepairMobileAdvantages/CenterMobileIRepairMobileAdvantages";
import CenterMobileIRepairMobileOrderForm from "../CenterMobileIRepairMobileOrderForm/CenterMobileIRepairMobileOrderForm";
import CenterMobileIRepairMobilePrice from "../CenterMobileIRepairMobilePrice/CenterMobileIRepairMobilePrice";
import CenterMobileIRepairMobileSelect from "../CenterMobileIRepairMobileSelect/CenterMobileIRepairMobileSelect";
import BreadCrumbs from "../../BreadCrumbs/BreadCrumbs";
import lenovoBanner from "../../../images/banners/mobile-lenovo-banner.png";
import icon1 from "../../../images/icons/center-mobile-advantages-icon.svg";
import icon2 from "../../../images/icons/center-mobile-advantages-icon-house.svg";
import icon3 from "../../../images/icons/center-mobile-advantages-icon-car.svg";
import icon4 from "../../../images/icons/center-mobile-advantages-icon-rocket.svg";
import {
  pricelists5mini,
  pricelist2Grand,
} from "../../../utils/CenterMobileSamsungPriceList";
import { Helmet } from "react-helmet";

const contentForAdvantages = [
  {
    img: icon1,
    title: "КАЧЕСТВЕННЫЙ СЕРВИС",
    text: "Мы постоянно работаем над повышением качества предоставляемых услуг, поэтому у нас предусмотрена такая возможность как «Вызов курьера» и «Бесплатная доставка». Для получения подробной информации можно связаться с нами по многоканальному телефону +7 (495) 540-43-19.",
  },
  {
    img: icon2,
    title: "ГАРАНТИЯ ОТ ПРОФЕССИОНАЛОВ",
    text: "«Центр Мобайл» предоставляет гарантию на все типы выполненных работ и установленные в смартфон детали. Срок гарантии определяется в зависимости от конкретных условий ремонта.",
  },
  {
    img: icon3,
    title: "ВЫЗОВ МАСТЕРА НА ДОМ",
    text: "При поломке, не требующей стационарного оборудования (например, замена экрана Lenovo), мастера можно вызвать на дом. В этом случае специалист приедет в удобное для вас время.",
  },
  {
    img: icon4,
    title: "СРОЧНЫЙ РЕМОНТ СМАРТФОНОВ LENOVO",
    text: "Мы понимаем, насколько вам важно ваше устройство, поэтому в определенных случаях можем выполнить срочный ремонт в вашем присутствии.",
  },
];

const mobiles = [
  { name: "K13", pricelist: pricelists5mini },
  { name: "K13 Note", pricelist: pricelist2Grand },
  { name: "Legion 2 Pro", pricelist: pricelists5mini },
  { name: "Legion Duel 2", pricelist: pricelist2Grand },
  { name: "K14 Plus", pricelist: pricelists5mini },
  { name: "Legion Y70", pricelist: pricelist2Grand },
  { name: "Legion Y90", pricelist: pricelists5mini },
];

const samsungMobilePrice = [
  {
    id: 1,
    text: "Диагностика",
    price: "Бесплатно",
    time: "30 минут",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 2,
    text: "Замена микросхем телефона",
    price: "от 900 P",
    time: "2-3 часа",
  },
  {
    id: 3,
    text: "Замена батареи",
    price: "от 300 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 4,
    text: "Замена экрана",
    price: "от 900 P",
    time: "2 часа",
  },
  {
    id: 5,
    text: "Ремонт цепи питания",
    price: "990 P",
    time: "3-4 часа",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 6,
    text: "Замена стекла",
    price: "от 800 P",
    time: "1-2 часа",
  },
  {
    id: 7,
    text: "Замена динамика",
    price: "от 280 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 8,
    text: "Замена разъема зарядки",
    price: "700-900 P",
    time: "1 час",
  },
  {
    id: 9,
    text: "Ремонт кнопки",
    price: "от 440 Р",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 10,
    text: "Замена задней крышки",
    price: "от 390 P",
    time: "4-5 часов",
  },
  {
    id: 11,
    text: "Ремонт системной платы",
    price: "1900 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
];

const samsungMobilePrice2 = [
  {
    id: 1,
    text: "Диагностика",
    price: "Бесплатно",
    time: "30 минут",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 2,
    text: "Восстановление прошивки",
    price: "890 P",
    time: "1 час",
  },
  {
    id: 3,
    text: "Чистка от жидкости",
    price: "890 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 4,
    text: "Восстановление данных",
    price: "890 P",
    time: "2-3 часа",
  },
  {
    id: 5,
    text: "Мелкий ремонт",
    price: "от 1500 P",
    time: "4-5 часов",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
  {
    id: 6,
    text: "Чистка от пыли",
    price: "от 390 P",
    time: "1 час",
  },
  {
    id: 7,
    text: "Перепрошивка",
    price: "700 P",
    time: "1 час",
    color: "#FFFFFF",
    boxShadow: "0px 0px 134px rgba(0, 0, 0, 0.05)",
  },
];

function CenterMobileRepairMobileLenovo() {
  return (
    <Page title="Услуги по ремонту смартфонов Lenovo, ремонт телефонов Леново в Москве">
      <main className={styles.content}>
        <Helmet>
          <link
            rel="canonical"
            href="http://localhost:3000/center-mobile/remont-smartfonov-lenovo"
          />
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Качественный ремонт и обслуживание телефонов Леново в Москве предлагают опытные мастера компании Oh!MyGadget!. Полный перечень работ по ремонту смартфонов Lenovo. Доступные цены, гарантии."
          />
        </Helmet>
        <CenterMobileIRepairMobileBanner
          image={lenovoBanner}
          alt="смартфон Lenovo"
          title="смартфон Lenovo"
        />
        <BreadCrumbs />
        <CenterMobileIRepairMobileCallback />
        <CenterMobileIRepairMobileInfo
          title="РЕМОНТ СМАРТФОНОВ LENOVO"
          text="Если вас подвел ваш мобильный телефон, и вы срочно ищете, где делают качественный ремонт смартфонов Lenovo в Москве, обращайтесь в Oh!MyGadget! Квалифицированные специалисты с многолетним опытом работы решат все ваши проблемы. Мы с одинаковой ответственностью ремонтируем как дорогостоящие смартфоны, так и модели телефонов Леново попроще."
        />
        <CenterMobileIRepairMobileSelect
          title="Цены на ремонт Lenovo"
          text="Для уточнения стоимости услуг по ремонту, выберите вашу модель
            Lenovo:"
          mobiles={mobiles}
        />
        <CenterMobileIRepairMobileAdvantages
          title="ПРЕИМУЩЕСТВА РЕМОНТА СМАРТФОНОВ ЛЕНОВО В «ЦЕНТР МОБАЙЛ»"
          titleMobile="Наши преимущества"
          contentForAdvantages={contentForAdvantages}
        />
        <CenterMobileIRepairMobileOrderForm
          title="КАК С НАМИ СВЯЗАТЬСЯ ?"
          text="Приезжайте к нам в офис, расположенный по адресу: Москва, ул. Лесная, 1/2, офис 351 (ст. метро Белорусская), звоните по телефону или пишите на электронную почту. Наши сотрудники оперативно свяжутся с вами, примут заказ и даже сами доставят ваш смартфон к нам в центр. Клиентоориентированный сервис – наше кредо!"
        />
        <CenterMobileIRepairMobilePrice
          samsungMobilePrice={samsungMobilePrice}
          samsungMobilePrice2={samsungMobilePrice2}
        />
      </main>
    </Page>
  );
}

export default CenterMobileRepairMobileLenovo;
